import { isNullOrUndefined } from '@app/util/util';
import {
  ItineraryHistoryDetail,
  ItineraryDetail, AirValidationSector,
  AirValidationFlightsSector
} from '@seat-map/entities/itinerary-detail';

import { PassengersSeatMap } from '@seat-map/entities/seat-map';

export function mapFlightNumberByFlightIdx(itineraryDetail: ItineraryHistoryDetail,
  flightIdx: number): AirValidationFlightsSector {
  let countFlight = 0;
  let flightSelected = null;
  for (const _sector of itineraryDetail.Reservations[0].Sectors) {
    if (flightSelected) {
      break;
    }
    for (const _flight of _sector.Flights) {
      if ((countFlight + 1) === flightIdx) {
        flightSelected = _flight;
        break;
      } else {
        countFlight = countFlight + 1;
      }
    }
  }
  if (flightSelected) {
    return flightSelected;
  } else {
    return null;
  }
}

export function mapItineraryDetail(itineraryDetail: ItineraryHistoryDetail, flightIdx: number): ItineraryDetail {
  const sectors = [];
  let countFlights = 0;
  itineraryDetail?.Reservations[0].Sectors.forEach(sector => {
    const flights = [];
    sector.Flights.forEach(flight => {
      flights.push({
        ...flight,
        IsSelected: countFlights === flightIdx
      });
      countFlights = countFlights + 1;
    });
    sectors.push({
      SectorNumber: sector.SectorNumber,
      TotalDuration: sector.TotalDuration,
      Flights: flights,
      IsSelected: flights.find(x => x.IsSelected)
    });
  });
  return {
    Id: itineraryDetail.Id,
    AirReservationId: itineraryDetail?.Reservations[0]?.Id,
    Sectors: sectors,
    Passengers: itineraryDetail?.Reservations[0].Passengers
  } as ItineraryDetail;
}

export function mapTotalFlightIdx(itineraryDetail: ItineraryHistoryDetail): number {
  let countFlights = -1;
  itineraryDetail?.Reservations[0].Sectors.forEach(sector => {
    sector.Flights.forEach(flight => {
      countFlights = countFlights + 1;
    });
  });
  return countFlights;
}

export function mapSectorAndFlightSelected(itineraryDetail: ItineraryDetail): AirValidationSector {
  if (isNullOrUndefined(itineraryDetail) || itineraryDetail?.Sectors?.length <= 0) {
    return null;
  }
  let sectorSelected = itineraryDetail.Sectors?.find(x => x.IsSelected);
  if (!sectorSelected) {
    sectorSelected = itineraryDetail.Sectors[0];
  }
  return {
    SectorNumber: sectorSelected?.SectorNumber,
    TotalDuration: sectorSelected?.TotalDuration,
    IsSelected: sectorSelected?.IsSelected,
    Flights: sectorSelected?.Flights,
  } as AirValidationSector;
}

export function mapSelectSectorItineraryDetail(itineraryDetail: ItineraryDetail, sector: number): ItineraryDetail {
  const sectors: AirValidationSector[] = [];
  itineraryDetail.Sectors?.forEach(_sector => {
    const flights = [];
    _sector.Flights.forEach((flight, i) => {
      flights.push({
        ...flight,
        IsSelected: sector === _sector.SectorNumber ? i === 0 : false
      });
    });
    sectors.push({
      ..._sector,
      Flights: flights,
      IsSelected: sector === _sector.SectorNumber
    });
  });
  return {
    ...itineraryDetail,
    Sectors: sectors
  };
}

export function mapSelectFlightItineraryDetail(itineraryDetail: ItineraryDetail,
  flight: AirValidationFlightsSector): ItineraryDetail {
  const allSectors = [];

  itineraryDetail.Sectors?.forEach(_sector => {
    const flightsSector = [];
    if (_sector.IsSelected) {
      _sector.Flights.forEach(_flight => {
        flightsSector.push({
          ..._flight,
          IsSelected: _flight.Number === flight.Number
        });
      });
      allSectors.push({
        ..._sector,
        Flights: flightsSector
      }
      );
    } else {
      allSectors.push(_sector);
    }
  });
  return {
    ...itineraryDetail,
    Sectors: allSectors
  };
}

export function mapItineraryPassengers(itineraryDetail: ItineraryHistoryDetail): PassengersSeatMap[] {
  return itineraryDetail.Reservations[0].Passengers as PassengersSeatMap[];
}
export function mapSelectNextFlightItineraryDetail(itineraryDetail: ItineraryDetail, flightIdx: number): ItineraryDetail {
  const allSectors = [];
  let countSectors = 0;
  let countFlight = 0;
  itineraryDetail.Sectors.forEach(_sector => {
    const flightsSector = [];
    countSectors += _sector.Flights.length - 1;
    _sector.Flights.forEach(_flight => {
      flightsSector.push({
        ..._flight,
        IsSelected: countFlight === flightIdx + 1
      });
      countFlight++;
    });
    allSectors.push({
      ..._sector,
      Flights: flightsSector,
      IsSelected: countSectors <= flightIdx + 1
    }
    );
  });
  return {
    ...itineraryDetail,
    Sectors: allSectors
  };
}
